import React, { useEffect, useState } from 'react'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CFormSelect,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react'
import { URL__API } from 'src/axios'
import axios from 'axios'
import avatar from '../../../assets/images/avatars/Avatars.png'
import { format } from 'date-fns'
import Loading from 'src/components/Loading'
import DefaultLayout from 'src/layout/DefaultLayout'
import Paginated from '../../../components/paginated/Paginated'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilPen, cilPlus, cilSwapVertical, cilWarning, cilX } from '@coreui/icons'
import { Link } from 'react-router-dom'
import NoData from '../nodata/NoData'
import { PropTypes } from 'prop-types'
import * as toastr from 'toastr'
import 'toastr/build/toastr.css'
import unblock from '../../../assets/images/unblock.png'
import blOck from '../../../assets/images/block.png'
import lock from '../../../assets/lock.png'
import NoUsers from '../nodata/NoUsers'
import './user.css'

function Users({ history }) {
  const [users, setUsers] = useState([])
  const [usersSorted, setUsersSorted] = useState([])
  const [searchData, setSearchData] = useState([])
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(true)
  const [userId, setUserId] = useState('')
  const [isDelete, setIsDelete] = useState(false)
  const [block, setBlock] = useState([])
  const [isBlock, setIsBlock] = useState([])
  const [empty, setEmpty] = useState(false)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const clients = await axios.get(`${URL__API}/user/all/users`, {
      headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    if ([200, 201].includes(clients.status)) {
      setLoading(false)
      setUsers(clients.data)
    }
  }

  const handleDelete = async (id) => {
    setVisible(true)
    if (visible === true) {
      await axios.delete(`${URL__API}/user/delete/${id}`, {
        headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      setVisible(false)
      setUserId('')
      fetchData()
      toastr.success('Cet utilisateur est supprimé avec succès', {
        positionClass: 'toast-bottom-left',
      })
    }
  }

  const fetchBlockUsers = async () => {
    const blocked = await axios.get(`${URL__API}/user/blocks`, {
      headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
    })

    setBlock(blocked.data)
  }

  const handleVerification = async (id) => {
    await axios.put(`${URL__API}/verification/identity/${id}`, null, {
      headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    fetchData()
  }

  const handleBlock = async (id) => {
    setVisible(true)

    if (visible === true) {
      try {
        const res = await axios.post(`${URL__API}/user/${id}/block`, null, {
          headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
        })

        if (res.data.response.statusCode === 400) {
          toastr.error(res.data.message, {
            positionClass: 'toast-bottom-left',
          })
          setVisible(false)
          setUserId('')
        } else {
          setVisible(false)
          setUserId('')
          toastr.success('Ce bricoleur est bloqué avec succès', {
            positionClass: 'toast-bottom-left',
          })
        }

        fetchData()
        fetchBlockUsers()
      } catch (error) {
        console.error(error)
      }
    }
  }

  const handleSearch = async (text) => {
    if (text.length === 0) {
      setSearchData([])
      fetchData()
      return
    }
    const res = await axios.get(`${URL__API}/user/client/search/${text}`, {
      headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
    })

    if (res.data.length === 0) return
    setSearchData(res.data)
  }

  const handleUnBlock = async (id) => {
    setVisible(true)
    if (visible === true) {
      try {
        await axios.post(`${URL__API}/user/${id}/unblock`, null, {
          headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
        })
        setVisible(false)
        setUserId('')
        fetchData()
        fetchBlockUsers()

        toastr.success('Ce bricoleur est debloqué avec succès', {
          positionClass: 'toast-bottom-left',
        })
      } catch (error) {
        console.error(error)
      }
    }
  }

  const handleFilter = async (val) => {
    try {
      if (users.length > 0) {
        if (val === '1') {
          const res = await axios.get(`${URL__API}/user/filter?val=2`, {
            headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
          })

          if (res.data.status === 400 || res.data.length === 0) {
            setEmpty(true)
          } else {
            setEmpty(false)
          }

          setSearchData(res.data)
        } else if (val === '2') {
          const res = await axios.get(`${URL__API}/user/filter?val=3`, {
            headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
          })

          if (res.data.status === 400 || res.data.length === 0) {
            setEmpty(true)
          } else {
            setEmpty(false)
          }

          setSearchData(res.data)
        } else if (val === '5') {
          const res = await axios.get(`${URL__API}/user/filter/bricoleurs?val=5`, {
            headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
          })

          if (res.data.status === 400 || res.data.length === 0) {
            setEmpty(true)
          } else {
            setEmpty(false)
          }

          setSearchData(res.data)
        } else if (val === '6') {
          const res = await axios.get(`${URL__API}/user/filter/bricoleurs?val=6`, {
            headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
          })
          if (res.data.status === 400 || res.data.length === 0) {
            setEmpty(true)
          } else {
            setEmpty(false)
          }
          setSearchData(res.data)
        } else if (val === 'names') {
          const res = await axios.get(`${URL__API}/user/filter?val=0`, {
            headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
          })

          if (res.data.status === 400 || res.data.length === 0) {
            setEmpty(true)
          } else {
            setEmpty(false)
          }

          setSearchData(res.data)
        } else if (val === 'email') {
          const res = await axios.get(`${URL__API}/user/filter?val=1`, {
            headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
          })

          if (res.data.status === 400 || res.data.length === 0) {
            setEmpty(true)
          } else {
            setEmpty(false)
          }

          setSearchData(res.data)
        } else if (val === 'job') {
          const res = await axios.get(`${URL__API}/user/filter?val=2`, {
            headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
          })

          if (res.data.status === 400 || res.data.length === 0) {
            setEmpty(true)
          } else {
            setEmpty(false)
          }

          setSearchData(res.data)
        } else {
          const res = await axios.get(`${URL__API}/user/filter`, {
            headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
          })

          if (res.data.status === 400 || res.data.length === 0) {
            setEmpty(true)
          } else {
            setEmpty(false)
          }

          setSearchData(res.data)
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  if (loading) {
    return (
      <DefaultLayout>
        <Loading />
      </DefaultLayout>
    )
  }

  return (
    <DefaultLayout>
      {users.length === 0 ? (
        <NoUsers msg="utilisatuer" />
      ) : (
        <>
          <CModal alignment="center" visible={visible} onClose={() => setVisible(false)}>
            <CModalHeader>
              <CModalTitle>
                {' '}
                {isBlock ? 'Déblocage' : isDelete ? 'Suppression' : 'Blocage'}{' '}
              </CModalTitle>
            </CModalHeader>
            <CModalBody>
              {isBlock
                ? 'Etes-vous sûr de débloquer cet utilisateur ?'
                : ` Etes-vous sûr de ${isDelete ? 'supprimer' : 'bloquer'} cet utilisateur ? `}
            </CModalBody>
            <CModalFooter>
              <CButton color="secondary" onClick={() => setVisible(false)}>
                Non
              </CButton>
              <CButton
                color="primary"
                onClick={() => {
                  if (isDelete) {
                    handleDelete(userId)
                  } else if (isBlock) {
                    handleUnBlock(userId)
                  } else {
                    handleBlock(userId)
                  }
                }}
              >
                Oui
              </CButton>
            </CModalFooter>
          </CModal>

          <CRow>
            <Paginated items={searchData.length > 0 ? searchData : users}>
              {(paginatedUsers) => (
                <CCol xs>
                  <CCard className="mb-4">
                    <CHeader className="mr-4 userr_header">
                      <CCardHeader className="w-100">Utilisateurs</CCardHeader>
                      <CCol xs="2" className="user_col">
                        <label>La vérification:</label>
                        <CFormSelect
                          // style={{ width: '150px', height: 'fit-content' }}
                          // onChange={(e) => {
                          //   setFilters({ ...filters, time: e.currentTarget.value })
                          // }}
                          onChange={(e) => handleFilter(e.target.value)}
                          options={[
                            { value: 0, label: 'Tous' },
                            { value: 1, label: 'Vérifié' },
                            { value: 2, label: 'Non vérifié' },
                            // { value: 3, label: 'Mois' },
                          ]}
                        />
                      </CCol>
                      <CCol xs="2" className="user_col">
                        <label>Le blocage:</label>
                        <CFormSelect
                          // style={{ width: '150px', height: 'fit-content' }}
                          // onChange={(e) => {
                          //   setFilters({ ...filters, time: e.currentTarget.value })
                          // }}
                          onChange={(e) => handleFilter(e.target.value)}
                          options={[
                            { value: 0, label: 'Tous' },
                            { value: 5, label: 'Bloqué' },
                            { value: 6, label: 'Non bloqué' },
                          ]}
                        />
                      </CCol>
                      <CCol xs="6" className="w-25 user_col">
                        <CFormInput
                          type="text"
                          name="text"
                          placeholder="Rechercher ..."
                          onChange={(e) => handleSearch(e.target.value)}
                        />
                      </CCol>
                      <Link
                        to="/addusers"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          color: 'white',
                          background: '#2ACC96',
                          border: '#2ACC96',
                          textDecoration: 'none',
                          borderRadius: '20px',
                          margin: '20px',
                          paddingRight: '25px',
                          paddingLeft: '25px',
                          paddingBottom: '16px',
                          paddingTop: '16px',
                        }}
                      >
                        <CIcon icon={cilPlus} size="lg" style={{ marginRight: '12px' }}></CIcon>
                        Ajouter un utilisateur
                      </Link>
                    </CHeader>
                    {!empty ? (
                      <CCardBody>
                        <br />
                        <CTable align="middle" className="mb-0 border" hover responsive>
                          <CTableHead color="light">
                            <CTableRow>
                              <CTableHeaderCell className="text-center"></CTableHeaderCell>
                              <CTableHeaderCell
                                className="text-center"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleFilter('names')}
                              >
                                Nom complet
                                <CIcon
                                  icon={cilSwapVertical}
                                  size="sm"
                                  style={{ marginLeft: '3px' }}
                                />
                              </CTableHeaderCell>
                              <CTableHeaderCell
                                className="text-center"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleFilter('email')}
                              >
                                Email
                                <CIcon
                                  icon={cilSwapVertical}
                                  size="sm"
                                  style={{ marginLeft: '3px' }}
                                />
                              </CTableHeaderCell>
                              <CTableHeaderCell
                                className="text-center"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleFilter('dateAt')}
                              >
                                Date d&apos;inscription
                                <CIcon
                                  icon={cilSwapVertical}
                                  size="sm"
                                  style={{ marginLeft: '3px' }}
                                />
                              </CTableHeaderCell>
                              <CTableHeaderCell className="text-center">Téléphone</CTableHeaderCell>
                              <CTableHeaderCell className="text-center">Vérifié</CTableHeaderCell>
                              <CTableHeaderCell className="text-center">Actions</CTableHeaderCell>
                            </CTableRow>
                          </CTableHead>
                          <CTableBody>
                            {paginatedUsers &&
                              paginatedUsers.map((item, index) => (
                                <CTableRow v-for="item in tableItems" key={index}>
                                  <CTableDataCell className="text-center">
                                    <div
                                      style={{ width: '4rem', height: '4rem', textAlign: 'center' }}
                                    >
                                      <img
                                        alt="avatar"
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          borderRadius: '50%',
                                        }}
                                        src={item.avatar ? item.avatar : avatar}
                                      />
                                    </div>
                                  </CTableDataCell>
                                  <CTableDataCell className="text-center">
                                    <div>{item.firstName + ' ' + item.lastname}</div>
                                  </CTableDataCell>
                                  <CTableDataCell className="text-center">
                                    <div className="small text-medium-emphasis">
                                      <span>{item.email}</span>
                                    </div>
                                  </CTableDataCell>

                                  <CTableDataCell className="text-center">
                                    <span>{format(new Date(item.createdAt), 'MM/dd/yyyy')}</span>
                                  </CTableDataCell>
                                  <CTableDataCell className="text-center">
                                    <span> {item.phone} </span>
                                  </CTableDataCell>
                                  <CTableDataCell className="text-center">
                                    {item.isIdentityVerified ? (
                                      <svg
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle cx="15" cy="15" r="15" fill="#2ACC96" />
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M12.6667 21.8667L6 15.2L7.86667 13.3333L12.6667 18.1333L22.8 8L24.6667 9.86667L12.6667 21.8667Z"
                                          fill="white"
                                        />
                                      </svg>
                                    ) : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-evenly',
                                        }}
                                      >
                                        <svg
                                          onClick={() => handleVerification(item.id)}
                                          width="116"
                                          height="61"
                                          viewBox="0 0 116 61"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g filter="url(#filter0_d_2533_7899)">
                                            <rect
                                              x="16"
                                              y="10"
                                              width="84"
                                              height="29"
                                              rx="14.5"
                                              fill="#2ACC96"
                                            />
                                          </g>
                                          <path
                                            d="M41.5656 20.172L38.0796 30H35.0836L31.5976 20.172H34.1456L36.5816 27.592L39.0316 20.172H41.5656ZM49.9302 25.968C49.9302 26.192 49.9162 26.4253 49.8882 26.668H44.4702C44.5075 27.1533 44.6615 27.5267 44.9322 27.788C45.2122 28.04 45.5528 28.166 45.9542 28.166C46.5515 28.166 46.9668 27.914 47.2002 27.41H49.7482C49.6175 27.9233 49.3795 28.3853 49.0342 28.796C48.6982 29.2067 48.2735 29.5287 47.7602 29.762C47.2468 29.9953 46.6728 30.112 46.0382 30.112C45.2728 30.112 44.5915 29.9487 43.9942 29.622C43.3968 29.2953 42.9302 28.8287 42.5942 28.222C42.2582 27.6153 42.0902 26.906 42.0902 26.094C42.0902 25.282 42.2535 24.5727 42.5802 23.966C42.9162 23.3593 43.3828 22.8927 43.9802 22.566C44.5775 22.2393 45.2635 22.076 46.0382 22.076C46.7942 22.076 47.4662 22.2347 48.0542 22.552C48.6422 22.8693 49.0995 23.322 49.4262 23.91C49.7622 24.498 49.9302 25.184 49.9302 25.968ZM47.4802 25.338C47.4802 24.9273 47.3402 24.6007 47.0602 24.358C46.7802 24.1153 46.4302 23.994 46.0102 23.994C45.6088 23.994 45.2682 24.1107 44.9882 24.344C44.7175 24.5773 44.5495 24.9087 44.4842 25.338H47.4802ZM47.6482 20.186L44.2742 21.6V19.948L47.6482 18.324V20.186ZM53.5871 23.49C53.8671 23.0607 54.2171 22.7247 54.6371 22.482C55.0571 22.23 55.5238 22.104 56.0371 22.104V24.638H55.3791C54.7818 24.638 54.3338 24.7687 54.0351 25.03C53.7365 25.282 53.5871 25.73 53.5871 26.374V30H51.1931V22.188H53.5871V23.49ZM58.3854 21.376C57.9654 21.376 57.6201 21.2547 57.3494 21.012C57.0881 20.76 56.9574 20.452 56.9574 20.088C56.9574 19.7147 57.0881 19.4067 57.3494 19.164C57.6201 18.912 57.9654 18.786 58.3854 18.786C58.7961 18.786 59.1321 18.912 59.3934 19.164C59.6641 19.4067 59.7994 19.7147 59.7994 20.088C59.7994 20.452 59.6641 20.76 59.3934 21.012C59.1321 21.2547 58.7961 21.376 58.3854 21.376ZM59.5754 22.188V30H57.1814V22.188H59.5754ZM65.2303 24.176H63.9423V30H61.5483V24.176H60.6803V22.188H61.5483V21.964C61.5483 21.0027 61.8237 20.2747 62.3743 19.78C62.925 19.276 63.7323 19.024 64.7963 19.024C64.9737 19.024 65.1043 19.0287 65.1883 19.038V21.068C64.731 21.04 64.409 21.1053 64.2223 21.264C64.0357 21.4227 63.9423 21.7073 63.9423 22.118V22.188H65.2303V24.176ZM67.5592 21.376C67.1392 21.376 66.7939 21.2547 66.5232 21.012C66.2619 20.76 66.1312 20.452 66.1312 20.088C66.1312 19.7147 66.2619 19.4067 66.5232 19.164C66.7939 18.912 67.1392 18.786 67.5592 18.786C67.9699 18.786 68.3059 18.912 68.5672 19.164C68.8379 19.4067 68.9732 19.7147 68.9732 20.088C68.9732 20.452 68.8379 20.76 68.5672 21.012C68.3059 21.2547 67.9699 21.376 67.5592 21.376ZM68.7492 22.188V30H66.3552V22.188H68.7492ZM77.8481 25.968C77.8481 26.192 77.8342 26.4253 77.8062 26.668H72.3882C72.4255 27.1533 72.5795 27.5267 72.8501 27.788C73.1302 28.04 73.4708 28.166 73.8722 28.166C74.4695 28.166 74.8848 27.914 75.1181 27.41H77.6662C77.5355 27.9233 77.2975 28.3853 76.9522 28.796C76.6162 29.2067 76.1915 29.5287 75.6782 29.762C75.1648 29.9953 74.5908 30.112 73.9561 30.112C73.1908 30.112 72.5095 29.9487 71.9121 29.622C71.3148 29.2953 70.8481 28.8287 70.5121 28.222C70.1761 27.6153 70.0081 26.906 70.0081 26.094C70.0081 25.282 70.1715 24.5727 70.4981 23.966C70.8341 23.3593 71.3008 22.8927 71.8981 22.566C72.4955 22.2393 73.1815 22.076 73.9561 22.076C74.7122 22.076 75.3842 22.2347 75.9722 22.552C76.5602 22.8693 77.0175 23.322 77.3442 23.91C77.6802 24.498 77.8481 25.184 77.8481 25.968ZM75.3982 25.338C75.3982 24.9273 75.2582 24.6007 74.9782 24.358C74.6982 24.1153 74.3482 23.994 73.9282 23.994C73.5268 23.994 73.1862 24.1107 72.9062 24.344C72.6355 24.5773 72.4675 24.9087 72.4022 25.338H75.3982ZM81.5051 23.49C81.7851 23.0607 82.1351 22.7247 82.5551 22.482C82.9751 22.23 83.4418 22.104 83.9551 22.104V24.638H83.2971C82.6998 24.638 82.2518 24.7687 81.9531 25.03C81.6544 25.282 81.5051 25.73 81.5051 26.374V30H79.1111V22.188H81.5051V23.49Z"
                                            fill="white"
                                          />
                                          <defs>
                                            <filter
                                              id="filter0_d_2533_7899"
                                              x="0"
                                              y="0"
                                              width="116"
                                              height="61"
                                              filterUnits="userSpaceOnUse"
                                              colorInterpolationFilters="sRGB"
                                            >
                                              <feFlood
                                                floodOpacity="0"
                                                result="BackgroundImageFix"
                                              />
                                              <feColorMatrix
                                                in="SourceAlpha"
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                result="hardAlpha"
                                              />
                                              <feOffset dy="6" />
                                              <feGaussianBlur stdDeviation="8" />
                                              <feComposite in2="hardAlpha" operator="out" />
                                              <feColorMatrix
                                                type="matrix"
                                                values="0 0 0 0 0.166667 0 0 0 0 0.8 0 0 0 0 0.588889 0 0 0 0.2 0"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in2="BackgroundImageFix"
                                                result="effect1_dropShadow_2533_7899"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="effect1_dropShadow_2533_7899"
                                                result="shape"
                                              />
                                            </filter>
                                          </defs>
                                        </svg>
                                      </div>
                                    )}
                                  </CTableDataCell>
                                  <CTableDataCell className="text-center " style={{ width: '15%' }}>
                                    <div
                                      className="text-center"
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <Link to={`/user/${item.id}`}>
                                        <CIcon
                                          icon={cilPen}
                                          title="Modifie"
                                          style={{
                                            color: '#2ACC96',
                                            border: '2px solid #2ACC96',
                                            borderRadius: '100%',
                                            margin: '9px',
                                            cursor: 'pointer',
                                          }}
                                          size="xl"
                                        />
                                      </Link>
                                      <span>
                                        <CIcon
                                          title="supprimer"
                                          icon={cilX}
                                          style={{
                                            cursor: 'pointer',
                                            color: 'red',
                                            border: '2px solid red',
                                            borderRadius: '100%',
                                            margin: '9px',
                                          }}
                                          size="xl"
                                          onClick={() => {
                                            setVisible(true)
                                            setIsDelete(true)
                                            setIsBlock(false)
                                            setUserId(item.id)
                                          }}
                                        />
                                      </span>
                                      {/* <img
                                      src={block}
                                      alt="block"
                                      title="bloquer"
                                      style={{
                                        cursor: 'pointer',
                                        padding: '1px',
                                        margin: '9px',
                                      }}
                                    /> */}

                                      {item.isBlocked ? (
                                        <span
                                          onClick={() => {
                                            setIsDelete(false)
                                            setIsBlock(true)
                                            setVisible(true)
                                            setUserId(item.id)
                                          }}
                                        >
                                          <img
                                            src={unblock}
                                            alt="block"
                                            title={'Debloquer'}
                                            style={{
                                              cursor: 'pointer',
                                              padding: '1px',
                                              margin: '9px',
                                            }}
                                          />
                                        </span>
                                      ) : (
                                        <span
                                          onClick={() => {
                                            setIsDelete(false)
                                            setIsBlock(false)
                                            setVisible(true)
                                            setUserId(item.id)
                                          }}
                                        >
                                          <img
                                            src={blOck}
                                            alt="block"
                                            title={'bloquer'}
                                            style={{
                                              cursor: 'pointer',
                                              padding: '1px',
                                              margin: '9px',
                                            }}
                                          />
                                        </span>
                                      )}

                                      <span>
                                        <CIcon
                                          title="supprimer"
                                          icon={cilLockLocked}
                                          style={{
                                            cursor: 'pointer',
                                            borderRadius: '100%',
                                            marginTop: '4px',
                                            marginLeft: '4px',
                                          }}
                                          size="xl"
                                          onClick={() => {
                                            history.push(`${item.id}/change`)
                                          }}
                                        />
                                      </span>
                                    </div>
                                  </CTableDataCell>
                                </CTableRow>
                              ))}
                          </CTableBody>
                        </CTable>
                      </CCardBody>
                    ) : (
                      <CAlert
                        color="warning"
                        className="d-flex align-items-center w-100 mx-auto justify-content-center "
                      >
                        <CIcon
                          icon={cilWarning}
                          className="flex-shrink-0 me-2"
                          width={24}
                          height={24}
                        />
                        <div>Les données que vous voulez n{"'"}existent pas</div>
                      </CAlert>
                    )}
                  </CCard>
                </CCol>
              )}
            </Paginated>
          </CRow>
        </>
      )}
    </DefaultLayout>
  )
}

Users.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
}

export default Users
